export enum SchedulingPriority {
  ROUTINE = "Routine",
  URGENT = "Urgent",
  STAT = "STAT",
}

/** Whether a scheduling priority requires same/next-day handling. */
export function isStatOrUrgentPriority(priority: SchedulingPriority | string | null | undefined): boolean {
  return priority === SchedulingPriority.STAT || priority === SchedulingPriority.URGENT;
}
